import classNames from 'classnames';
import {connect} from 'react-redux';

import {getIndices} from '../../../general/selectors';

const TimeZoneName = ({Element = 'th', timezone}) => (
    <Element className="timezone-name">{timezone}</Element>
);

const Header = ({timezone, indices}) => (
    <thead>
        <tr>
            <TimeZoneName timezone={timezone} />
            {indices.map(({key, title, label, className, current}) => (
                <th key={key} className={classNames({current})} title={title}>
                    <span className={className}>
                        {label}
                    </span>
                </th>
            ))}
        </tr>
    </thead>
);

const mapStateToProps = state => ({
    indices: getIndices(state),
    timezone: state.timezone,
});

export default connect(mapStateToProps)(Header);
